import { useSelector } from 'react-redux';
import { authSelector } from '../../store';
import type { ExternalTeam, InternalTeam } from '../../types/Project';

export default function useAccessControl() {
  const { data: currentUserData } = useSelector(authSelector);

  const roleLevel: { [key: number]: string } = {
    0: 'SUPER_ADMIN',
    1: 'ADMIN',
    2: 'PROJECT_MANAGER',
    3: 'PROJECT_ASSOCIATE',
    4: 'OBSERVER',
  };

  const isAllowedToAccess = (requiredRoles: number[]) => {
    const roles: string[] = [];
    requiredRoles.forEach((r: number) => {
      roles.push(roleLevel[r]);
    });

    return roles.includes(currentUserData.roleValue);
  };

  const canAccess = (requiredRoles: string[]) => {
    let access = false;
    requiredRoles.forEach((r: string) => {
      if (r === 'ALL') {
        access = true;
      } else if (r === currentUserData.roleValue) {
        access = true;
      }
    });

    return access;
  };

  const isProjectLead = (projectLeadId: number) => {
    return projectLeadId === currentUserData.id;
  };

  const isProjectMember = (projectTeam: InternalTeam[] | ExternalTeam[] | undefined) => {
    let member = false;
    if (projectTeam) {
      projectTeam.forEach((m) => {
        if (m.id === currentUserData.id) {
          member = true;
        }
      });
    }
    return member;
  };

  const isProjectPhaseMember = (phaseTeam: InternalTeam[] | ExternalTeam[] | undefined) => {
    let member = false;
    if (phaseTeam) {
      phaseTeam.forEach((m) => {
        if (m.id === currentUserData.id) {
          member = true;
        }
      });
    }
    return member;
  };

  return {
    canAccess,
    isAllowedToAccess,
    isProjectLead,
    isProjectMember,
    isProjectPhaseMember,
  };
}
